import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["screen", "step"]

  static values = {
    screens: Array,
  }

  connect() {
    if (!this.hasScreensValue) return
    this.show(0)
  }

  select(event) {
    const index = Number(event.currentTarget.dataset.index)
    this.show(index)
  }

  show(index) {
    const screen = this.screensValue[index]
    if (!screen) return

    this.screenTarget.classList.add("opacity-40")
    this.screenTarget.src = screen.src
    this.screenTarget.alt = screen.alt
    requestAnimationFrame(() => {
      this.screenTarget.classList.remove("opacity-40")
    })

    this.stepTargets.forEach((step, i) => {
      const active = i === index
      step.classList.toggle("border-success/50", active)
      step.classList.toggle("bg-success/5", active)
      step.classList.toggle("border-base-300", !active)
      step.classList.toggle("opacity-60", !active)
      step.setAttribute("aria-current", active ? "step" : "false")
    })
  }
}
